import type { DayPlan } from '@/lib/index';

export const weeklyPlan: DayPlan[] = [
  {
    day: 'Day 1',
    dayAr: 'اليوم الأول',
    dayNum: 1,
    meals: [
      {
        type: 'breakfast',
        label: 'Breakfast',
        emoji: '🌅',
        items: [
          { name: 'Coffee', amount: '1 cup' },
          { name: 'Brown Toast', amount: '4 slices' },
          { name: 'Eggs Omelette', amount: '4 eggs' },
          { name: 'Salad', amount: '150g' },
        ],
      },
      {
        type: 'meal2',
        label: 'Meal 2',
        emoji: '🍽️',
        items: [
          { name: 'Rice', amount: '150g' },
          { name: 'Chicken Breast', amount: '200g' },
        ],
      },
      {
        type: 'meal3',
        label: 'Meal 3',
        emoji: '🥗',
        items: [
          { name: 'Rice', amount: '200g' },
          { name: 'Chicken Breast', amount: '200g' },
          { name: 'Salad', amount: '150g' },
        ],
      },
      {
        type: 'snack',
        label: 'Snack 1',
        emoji: '🧀',
        items: [
          { name: 'Cheese (low salt)', amount: '100g' },
          { name: 'Brown Toast', amount: '2 slices' },
        ],
      },
      {
        type: 'dinner',
        label: 'Dinner',
        emoji: '🌙',
        items: [
          { name: 'Greek Yogurt + Cocoa', amount: '1 cup' },
          { name: 'Banana', amount: '50g' },
          { name: 'Strawberry', amount: '50g' },
          { name: 'Mixed Nuts', amount: '70g' },
        ],
      },
    ],
  },
  {
    day: 'Day 2',
    dayAr: 'اليوم الثاني',
    dayNum: 2,
    meals: [
      {
        type: 'breakfast',
        label: 'Breakfast',
        emoji: '🌅',
        items: [
          { name: 'Cheese (low salt)', amount: '100g' },
          { name: 'Eggs Omelette with Veggies', amount: '3 eggs' },
          { name: 'Salad', amount: '150g' },
          { name: 'Baladi Bread', amount: '1 loaf' },
          { name: 'Coffee', amount: '1 cup' },
        ],
      },
      {
        type: 'pre-workout',
        label: 'Pre-Workout',
        emoji: '⚡',
        items: [
          { name: 'Boiled Potatoes', amount: '200g' },
          { name: 'Coffee', amount: '1 cup' },
        ],
      },
      {
        type: 'post-workout',
        label: 'Post-Workout',
        emoji: '💪',
        items: [
          { name: 'Rice', amount: '250g' },
          { name: 'Lean Meat', amount: '300g' },
          { name: 'Salad', amount: '150g' },
        ],
      },
      {
        type: 'snack',
        label: 'Snack',
        emoji: '🥛',
        items: [
          { name: 'Cottage Cheese (Qareesh)', amount: '200g' },
          { name: 'Salad', amount: '100g' },
          { name: 'Brown Toast', amount: '2 slices' },
        ],
      },
      {
        type: 'dinner',
        label: 'Dinner',
        emoji: '🌙',
        items: [
          { name: 'Lupine (Termis)', amount: '150g' },
        ],
      },
    ],
  },
  {
    day: 'Day 3',
    dayAr: 'اليوم الثالث',
    dayNum: 3,
    meals: [
      {
        type: 'breakfast',
        label: 'Breakfast',
        emoji: '🌅',
        items: [
          { name: 'Salad', amount: '150g' },
          { name: 'Cheese (low salt)', amount: '100g' },
          { name: 'Baladi Bread', amount: '1 loaf' },
          { name: 'Tuna (no oil)', amount: '100g' },
        ],
      },
      {
        type: 'pre-workout',
        label: 'Pre-Workout',
        emoji: '⚡',
        items: [
          { name: 'Boiled Potatoes', amount: '150g' },
          { name: 'Coffee', amount: '1 cup' },
          { name: 'Banana', amount: '1 medium' },
        ],
      },
      {
        type: 'post-workout',
        label: 'Post-Workout',
        emoji: '💪',
        items: [
          { name: 'Lean Meat', amount: '250g' },
          { name: 'Salad', amount: '150g' },
          { name: 'Basmati Rice', amount: '150g' },
        ],
      },
      {
        type: 'snack',
        label: 'Snack',
        emoji: '🍓',
        items: [
          { name: 'Cream of Rice', amount: '150g' },
          { name: 'Warm Full-Fat Milk', amount: '150ml' },
          { name: 'Cocoa + Honey', amount: '1 tsp each' },
          { name: 'Banana', amount: '30g' },
          { name: 'Strawberry', amount: '30g' },
        ],
      },
    ],
  },
  {
    day: 'Day 4',
    dayAr: 'اليوم الرابع',
    dayNum: 4,
    meals: [
      {
        type: 'breakfast',
        label: 'Breakfast',
        emoji: '🌅',
        items: [
          { name: 'Cottage Cheese (Qareesh)', amount: '200g' },
          { name: 'Eggs', amount: '2 eggs' },
          { name: 'Baladi Bread', amount: '1 loaf' },
          { name: 'Salad', amount: '150g' },
        ],
      },
      {
        type: 'pre-workout',
        label: 'Pre-Workout',
        emoji: '⚡',
        items: [
          { name: 'Roasted/Boiled Potatoes', amount: '150g' },
          { name: 'Honey', amount: '1 tsp' },
          { name: 'Banana', amount: '1 medium' },
          { name: 'Coffee', amount: '1 cup' },
        ],
      },
      {
        type: 'post-workout',
        label: 'Post-Workout',
        emoji: '💪',
        items: [
          { name: 'Grilled Liver', amount: '200g' },
          { name: 'Salad', amount: '150g' },
          { name: 'Rice', amount: '100g' },
        ],
      },
    ],
  },
  {
    day: 'Day 5',
    dayAr: 'اليوم الخامس',
    dayNum: 5,
    meals: [
      {
        type: 'breakfast',
        label: 'Breakfast',
        emoji: '🌅',
        items: [
          { name: 'Fava Beans (Foul)', amount: '150g' },
          { name: 'Eggs (1 without yolk)', amount: '3 eggs' },
          { name: 'Vegetables', amount: '100g' },
          { name: 'Coffee', amount: '1 cup' },
          { name: 'Salad', amount: '100g' },
        ],
      },
      {
        type: 'pre-workout',
        label: 'Pre-Workout',
        emoji: '⚡',
        items: [
          { name: 'Rice', amount: '150g' },
          { name: 'Banana', amount: '1 medium' },
          { name: 'Coffee', amount: '1 cup' },
          { name: 'Dates', amount: '3 pieces' },
        ],
      },
      {
        type: 'post-workout',
        label: 'Post-Workout',
        emoji: '💪',
        items: [
          { name: 'Rice', amount: '150g' },
          { name: 'Fish', amount: '250g' },
          { name: 'Salad', amount: '150g' },
        ],
      },
      {
        type: 'dinner',
        label: 'Dinner',
        emoji: '🌙',
        items: [
          { name: 'Greek Yogurt', amount: '1 cup' },
          { name: 'Fruits', amount: '50g' },
          { name: 'Honey', amount: '1 tsp' },
        ],
      },
    ],
  },
  {
    day: 'Day 6',
    dayAr: 'اليوم السادس',
    dayNum: 6,
    meals: [
      {
        type: 'breakfast',
        label: 'Breakfast',
        emoji: '🌅',
        items: [
          { name: 'Air-Fryer Potatoes', amount: '150g' },
          { name: 'Salad', amount: '100g' },
          { name: 'Baladi Bread', amount: '½ loaf' },
          { name: 'Eggs Omelette', amount: '4 eggs' },
        ],
      },
      {
        type: 'pre-workout',
        label: 'Pre-Workout',
        emoji: '⚡',
        items: [
          { name: 'Potatoes', amount: '150g' },
          { name: 'Honey', amount: '1 tsp' },
        ],
      },
      {
        type: 'post-workout',
        label: 'Post-Workout',
        emoji: '💪',
        items: [
          { name: 'Pasta with Tomato Sauce', amount: '200g' },
          { name: 'Lean Ground Meat', amount: '300g' },
        ],
      },
      {
        type: 'dinner',
        label: 'Dinner',
        emoji: '🌙',
        items: [
          { name: 'Cottage Cheese (Qareesh)', amount: '150g' },
          { name: 'Vegetables', amount: '100g' },
        ],
      },
      {
        type: 'snack',
        label: 'Snack',
        emoji: '🍓',
        items: [
          { name: 'Cream of Rice (Strawberry flavor)', amount: '150g' },
        ],
      },
    ],
  },
  {
    day: 'Day 7',
    dayAr: 'اليوم السابع',
    dayNum: 7,
    meals: [
      {
        type: 'breakfast',
        label: 'Breakfast',
        emoji: '🌅',
        items: [
          { name: 'Fava Beans (Foul)', amount: '150g' },
          { name: 'Air-Fryer Falafel', amount: '3 pieces' },
          { name: 'Turkish Cheese', amount: '50g' },
          { name: 'Salad', amount: '100g' },
          { name: 'Baladi Bread', amount: '1 loaf' },
        ],
      },
      {
        type: 'meal2',
        label: 'Meal 2',
        emoji: '🍽️',
        items: [
          { name: 'Rice', amount: '200g' },
          { name: 'Liver', amount: '200g' },
          { name: 'Salad', amount: '150g' },
        ],
      },
      {
        type: 'meal3',
        label: 'Meal 3',
        emoji: '🥗',
        items: [
          { name: 'Chicken', amount: '200g' },
          { name: 'Salad', amount: '150g' },
        ],
      },
      {
        type: 'snack',
        label: 'Snack',
        emoji: '🥜',
        items: [
          { name: 'Lupine (Termis)', amount: '200g' },
          { name: 'Popcorn', amount: '50g' },
        ],
      },
    ],
  },
];

export const mealTypeConfig = {
  breakfast: {
    color: 'text-amber-400',
    bg: 'bg-amber-400/10',
    border: 'border-amber-400/30',
    dot: 'bg-amber-400',
    label: 'Breakfast',
  },
  'pre-workout': {
    color: 'text-orange-400',
    bg: 'bg-orange-400/10',
    border: 'border-orange-400/30',
    dot: 'bg-orange-400',
    label: 'Pre-Workout',
  },
  'post-workout': {
    color: 'text-green-400',
    bg: 'bg-green-400/10',
    border: 'border-green-400/30',
    dot: 'bg-green-400',
    label: 'Post-Workout',
  },
  snack: {
    color: 'text-purple-400',
    bg: 'bg-purple-400/10',
    border: 'border-purple-400/30',
    dot: 'bg-purple-400',
    label: 'Snack',
  },
  dinner: {
    color: 'text-blue-400',
    bg: 'bg-blue-400/10',
    border: 'border-blue-400/30',
    dot: 'bg-blue-400',
    label: 'Dinner',
  },
  meal2: {
    color: 'text-cyan-400',
    bg: 'bg-cyan-400/10',
    border: 'border-cyan-400/30',
    dot: 'bg-cyan-400',
    label: 'Meal 2',
  },
  meal3: {
    color: 'text-teal-400',
    bg: 'bg-teal-400/10',
    border: 'border-teal-400/30',
    dot: 'bg-teal-400',
    label: 'Meal 3',
  },
};
